export const personalInfo = {
  name: "Zahir Tanin",
  title: "React Native Developer",
  tagline: "Building cross-platform mobile apps with React Native and AWS backends",
  bio: "React Native Developer with 3 years of experience building high-performance, cross-platform Android and iOS applications. Proven track record shipping a production app to Google Play and the Apple App Store with a fully serverless AWS backend.",
  email: "a.zahirtanin786@gmail.com",
  phone: "+93 779 683 549",
  location: "Available for Remote & On-site Opportunities",
  links: {
    github: "https://github.com/zahirtanin1397",
    // No LinkedIn or Twitter — add real ones here if you create them.
  },
  avatar: "/avatar.jpg",
  resume: "/zahircv.pdf",
};

export const techStack = [
  { name: "React Native", category: "Languages & Frameworks", proficiency: 92 },
  { name: "JavaScript", category: "Languages & Frameworks", proficiency: 92 },
  { name: "TypeScript", category: "Languages & Frameworks", proficiency: 85 },
  { name: "React", category: "Languages & Frameworks", proficiency: 85 },

  { name: "AWS Amplify", category: "AWS Cloud", proficiency: 85 },
  { name: "AppSync", category: "AWS Cloud", proficiency: 80 },
  { name: "Cognito", category: "AWS Cloud", proficiency: 82 },
  { name: "AWS Lambda", category: "AWS Cloud", proficiency: 80 },
  { name: "DynamoDB", category: "AWS Cloud", proficiency: 80 },
  { name: "S3", category: "AWS Cloud", proficiency: 82 },

  { name: "REST API", category: "APIs & Realtime", proficiency: 90 },
  { name: "GraphQL", category: "APIs & Realtime", proficiency: 82 },
  { name: "WebSockets", category: "APIs & Realtime", proficiency: 78 },

  { name: "SQLite", category: "Data & Storage", proficiency: 80 },
  { name: "AsyncStorage", category: "Data & Storage", proficiency: 85 },
  { name: "Offline Sync", category: "Data & Storage", proficiency: 82 },

  { name: "FCM", category: "Notifications", proficiency: 85 },
  { name: "APNs", category: "Notifications", proficiency: 80 },
  { name: "Expo Notifications", category: "Notifications", proficiency: 80 },

  { name: "EAS Build & Submit", category: "Delivery", proficiency: 85 },
  { name: "CI/CD", category: "Delivery", proficiency: 82 },
  { name: "GitHub Actions", category: "Delivery", proficiency: 78 },
  { name: "Git/GitHub", category: "Delivery", proficiency: 90 },
];

export const projects = [
  {
    id: 1,
    title: "Memento Language",
    description: "Language-learning app with AI conversation practice, real-time chat, and voice/video calls — live on Google Play and the Apple App Store.",
    longDescription: "Memento Language helps people learn new languages through interactive practice: AI-powered conversation and pronunciation feedback, real-time chat and voice/video calls with other learners, spaced-repetition vocabulary, and step-by-step grammar lessons. Built end-to-end in React Native with a serverless AWS backend.",
    techStack: ["React Native", "TypeScript", "AWS Amplify", "AppSync", "Cognito", "Lambda", "DynamoDB", "S3", "WebSockets", "EAS Build"],
    features: [
      "AI-powered conversation practice and pronunciation feedback",
      "Real-time chat and voice/video calling between learners via WebSockets",
      "Data layer on AWS (DynamoDB, Cognito, Lambda, S3) with encrypted data in transit",
      "Push notifications on both platforms — APNs for iOS, FCM for Android",
      "CI/CD pipeline via EAS Build/Submit automating builds, versioning, and releases to both stores",
      "Spaced-repetition vocabulary builder and structured grammar lessons",
    ],
    images: [],
    links: {
      appStore: null, // add your App Store URL here
      playStore: "https://play.google.com/store/apps/details?id=com.zahirtanin.mementoLanguage&hl=en",
    },
    featured: true,
    status: "published",
    year: 2026,
  },
];

export const experience = [
  {
    id: 1,
    company: "Independent — add your employer name here if applicable",
    position: "React Native Developer",
    location: "Remote",
    startDate: "2023-01",
    endDate: null,
    current: true,
    description: "Designing and building cross-platform mobile applications for Android and iOS from a single React Native codebase, with serverless AWS backends.",
    achievements: [
      "Built scalable, maintainable application architectures with a focus on code quality and reusability",
      "Integrated cloud backends using AWS services (Amplify, AppSync, Cognito, Lambda, DynamoDB, S3)",
      "Implemented authentication, subscriptions, and push notifications (FCM for Android, APNs for iOS)",
      "Built offline-first data synchronization for a reliable experience on unstable connections",
      "Set up CI/CD pipelines with EAS Build/Submit to automate builds and releases to both app stores",
      "Optimized rendering performance and app startup time across devices",
    ],
    techStack: ["React Native", "TypeScript", "AWS Amplify", "Cognito", "Lambda", "DynamoDB", "EAS Build"],
  },
];

// Left empty intentionally — add real entries rather than placeholders.
export const education = [];

// Left empty intentionally — add real certifications if/when you earn them.
export const certifications = [];
